import { render, staticRenderFns } from "./personal_information_family_members.vue?vue&type=template&id=f58fc078&scoped=true&"
import script from "./personal_information_family_members.vue?vue&type=script&lang=js&"
export * from "./personal_information_family_members.vue?vue&type=script&lang=js&"
import style0 from "./personal_information_family_members.vue?vue&type=style&index=0&id=f58fc078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58fc078",
  null
  
)

export default component.exports